import CXMApiClient from "../../CXMApiClient";
import moment from "moment";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    activityCounts: [],
    recentEngagements: [],
    activityFeedCurrentPage: 0,
    activityFeedCurrentSize: 25,
    engagementFeedCurrentPage: 0,
    engagementFeedCurrentSize: 25,
    EmailConversationItems: null
  };
}

const state = initialState();

const getters = {
  activityCounts: function (state) {
    return state.activityCounts;
  },
  EmailConversationItems: function (state) {
    return state.EmailConversationItems;
  }
};

const actions = {
  loadActivityFeed: function (context, request) {
    if (request && request.RequestPayload) {
      request.RequestPayload.beginDate = moment(
        request.RequestPayload.beginDate
      ).startOf("day");
      request.RequestPayload.endDate = moment(
        request.RequestPayload.endDate
      ).endOf("day");
    }
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/crm/contacts/" + request.ContactId + "/activity/feed/paged",
          request.RequestPayload
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loadActivityCountByType: function (context, request) {
    if (request && request.RequestPayload) {
      request.RequestPayload.beginDate = moment(
        request.RequestPayload.beginDate
      ).startOf("day");
      request.RequestPayload.endDate = moment(
        request.RequestPayload.endDate
      ).endOf("day");
    }
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "/crm/contacts/" + request.ContactId + "/activity/counts",
            request.RequestPayload
          )
          .then(response => {
            if (response && response.data.successful) {
              context.commit("updateActivityCount", response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  loadRecentActivity: function (context, request) {
    if (request && request.RequestPayload) {
      request.RequestPayload.beginDate = moment(
        request.RequestPayload.beginDate
      ).startOf("day");
      request.RequestPayload.endDate = moment(
        request.RequestPayload.endDate
      ).endOf("day");
    }
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "/api/Activity/grouped/detail/sample",
            request.RequestPayload,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              context.commit("updateRecentActivities", response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getNoteById: async function (context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    let client = new CXMApiClient();
    return await client.ProcessRequest("get", "api/notes/" + request, null, scope).catch(err => err.response);
  },
  getEmailsByConversationId: async function (context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    const client = new CXMApiClient();
    const response = await client.ProcessRequest("post", "api/notes/get", request, scope).catch(err => err.response);
    context.commit("updateEmailConversationItems", response && response.data && response.data.successful ? response.data.data : null);
    return response;
  },
  getConversationDetailsByConversationId: function (context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "api/Activity/conversation/overview/",
            request,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getAllNotes: function (context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "api/notes/get/",
          request,
          request.accountPlatformId ? [request.accountPlatformId] : []
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateActivityFeedPage: function (context, data) {
    context.commit("updateActivityFeedPage", data);
  },
  updateEngagementFeedPage: function (context, data) {
    context.commit("updateEngagementFeedPage", data);
  },
  updateActivityFeedSize: function (context, data) {
    context.commit("updateActivityFeedSize", data);
  },
  updateEngagementFeedSize: function (context, data) {
    context.commit("updateEngagementFeedSize", data);
  },
  updateActivityCount: function (context, data) {
    context.commit("updateActivityCount", data);
  },
  updateRecentActivities: function (context, data) {
    context.commit("updateRecentActivities", data);
  }
};

const mutations = {
  updateActivityCount: function (state, data) {
    state.activityCounts = data;
  },
  updateRecentActivities: function (state, data) {
    state.recentEngagements = data;
  },
  updateActivityFeedPage: function (state, data) {
    state.activityFeedCurrentPage = data;
  },
  updateEngagementFeedPage: function (state, data) {
    state.engagementFeedCurrentPage = data;
  },
  updateActivityFeedSize: function (state, data) {
    state.activityFeedCurrentSize = data;
  },
  updateEngagementFeedSize: function (state, data) {
    state.engagementFeedCurrentSize = data;
  },
  updateEmailConversationItems: function (state, data) {
    state.EmailConversationItems = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Activity.js